import React from 'react';
import styled from 'styled-components';
import { FaListAlt, FaClipboardList, FaDollarSign, FaEdit} from 'react-icons/fa';

const SidebarContainer = styled.div`
  width: 250px;
  height: 100vh;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-right: 2px solid #ddd;
`;

const ProfilePicture = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-bottom: 20px;
`;

const UserName = styled.h3`
  margin-bottom: 20px;
`;

const SidebarButton = styled.button`
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  margin-bottom: 10px;
  color: #333;

  &:hover {
    background-color: #007bff;
    color: #fff;
  }

  svg {
    margin-right: 10px;
  }
`;

const Sidebar = ({ user, setActiveTab }) => {
  return (
    <SidebarContainer>
      <ProfilePicture src={user.picture_url} alt="Profile" />
      <UserName>{user.name}</UserName>

      {/* Buttons to switch between tabs */}
      <SidebarButton onClick={() => setActiveTab('listings')}>
        <FaListAlt /> My Listings
      </SidebarButton>
      <SidebarButton onClick={() => setActiveTab('reservations')}>
        <FaClipboardList /> Reservations
      </SidebarButton>
      <SidebarButton onClick={() => setActiveTab('bookings')}>
        <FaClipboardList /> Bookings
      </SidebarButton>
      {/* New Bank Account Details Button */}
      <SidebarButton onClick={() => setActiveTab('bankAccount')}>
        <FaDollarSign /> Bank Account 
      </SidebarButton>
      {/* <SidebarButton onClick={() => setActiveTab('earnings')}>
        <FaDollarSign /> My Earnings
      </SidebarButton> */}
      {/* <SidebarButton onClick={() => setActiveTab('editProfile')}>
        <FaEdit /> Edit Profile
      </SidebarButton> */}
    </SidebarContainer>
  );
};

export default Sidebar;
